export const seoConfig = {
  en: {
    title: "Gulf Neuron - AI Solutions & Machine Learning Development | Muscat, Oman",
    description: "Leading AI development company in Oman specializing in chatbots, RAG systems, machine learning models, generative AI, and custom AI integrations. Serving clients globally from Muscat.",
    keywords: "AI development Oman, machine learning Muscat, AI chatbot development, RAG systems, generative AI, AI integration, custom AI solutions, AI company Oman, deep learning, NLP, computer vision, predictive analytics, AI consulting Oman, artificial intelligence Gulf, AI tools development, text generation, image generation, speech recognition, AI automation, fine-tuning models",
    ogTitle: "Gulf Neuron - Transform Your Business with AI Innovation",
    ogDescription: "Expert AI development services including chatbots, machine learning models, generative AI, and seamless AI integration. Based in Muscat, serving global clients.",
    twitterCard: "summary_large_image"
  },
  ar: {
    title: "جولف نيورون - حلول الذكاء الاصطناعي وتطوير التعلم الآلي | مسقط، عمان",
    description: "شركة رائدة في تطوير الذكاء الاصطناعي في عمان متخصصة في روبوتات الدردشة، أنظمة RAG، نماذج التعلم الآلي، الذكاء الاصطناعي التوليدي، والتكاملات المخصصة. نخدم العملاء عالمياً من مسقط.",
    keywords: "تطوير الذكاء الاصطناعي عمان, التعلم الآلي مسقط, تطوير روبوت الدردشة بالذكاء الاصطناعي, أنظمة RAG, الذكاء الاصطناعي التوليدي, تكامل الذكاء الاصطناعي, حلول الذكاء الاصطناعي المخصصة, شركة ذكاء اصطناعي عمان, التعلم العميق, معالجة اللغة الطبيعية, رؤية الحاسوب, التحليلات التنبؤية, استشارات الذكاء الاصطناعي عمان, الذكاء الاصطناعي الخليج, تطوير أدوات الذكاء الاصطناعي, توليد النصوص, توليد الصور, التعرف على الكلام, أتمتة الذكاء الاصطناعي, ضبط النماذج",
    ogTitle: "Gulf Neuron - حوّل عملك مع الابتكار في الذكاء الاصطناعي",
    ogDescription: "خدمات تطوير الذكاء الاصطناعي الخبيرة بما في ذلك روبوتات الدردشة ونماذج التعلم الآلي والذكاء الاصطناعي التوليدي والتكامل السلس للذكاء الاصطناعي. مقرنا في مسقط، نخدم العملاء عالمياً.",
    twitterCard: "summary_large_image"
  }
};

// Structured Data for Rich Snippets (JSON-LD)
export const structuredData = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Gulf Neuron",
  "alternateName": ["Gulf Neuron AI", "جولف نيورون"],
  "url": "https://gulfneuron.com",
  "logo": "https://gulfneuron.com/logo.png",
  "description": "AI development company specializing in machine learning, chatbots, generative AI, and custom AI solutions",
  "email": "gulfneuron@gmail.com",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Muscat",
    "addressCountry": "OM"
  },
  "areaServed": [
    {
      "@type": "Country",
      "name": "Oman"
    },
    {
      "@type": "Country",
      "name": "United Arab Emirates"
    },
    {
      "@type": "Country",
      "name": "Saudi Arabia"
    },
    "Worldwide"
  ],
  "sameAs": [
    "https://linkedin.com/company/gulfneuron",
    "https://twitter.com/gulfneuron"
  ],
  "service": [
    {
      "@type": "Service",
      "name": "AI Chatbot Development",
      "description": "Custom conversational AI and chatbot development with RAG systems"
    },
    {
      "@type": "Service",
      "name": "Machine Learning Models",
      "description": "Predictive analytics and classification systems"
    },
    {
      "@type": "Service",
      "name": "Generative AI Solutions",
      "description": "Text, image, and audio generation systems"
    },
    {
      "@type": "Service",
      "name": "AI Integration",
      "description": "Seamless AI integration into existing systems"
    }
  ]
};

// Local Business Schema (Important for Oman/Gulf region)
export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Gulf Neuron",
  "image": "https://gulfneuron.com/logo.png",
  "@id": "https://gulfneuron.com",
  "url": "https://gulfneuron.com",
  "priceRange": "$$",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Muscat",
    "addressLocality": "Muscat",
    "postalCode": "XXX",
    "addressCountry": "OM"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 23.5880,
    "longitude": 58.3829
  },
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday"
    ],
    "opens": "09:00",
    "closes": "18:00"
  }
};

// FAQ Schema for Rich Results
export const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What AI services does Gulf Neuron provide?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Gulf Neuron provides comprehensive AI services including chatbot development, RAG systems, machine learning models, generative AI (text, image, audio), AI integration, predictive analytics, and custom AI tool development."
      }
    },
    {
      "@type": "Question",
      "name": "Where is Gulf Neuron located?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Gulf Neuron is based in Muscat, Oman, and serves clients both locally in the Gulf region and internationally worldwide."
      }
    },
    {
      "@type": "Question",
      "name": "Does Gulf Neuron work with international clients?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, Gulf Neuron serves clients globally. While based in Muscat, we work remotely with businesses worldwide."
      }
    }
  ]
};